"use strict"

import { Data } from '@/lib/core/components/data/data'
import { irParaTerrenoButton } from '@/lib/core/terrenos/terrenosFormShared'

export class TerrenosLinks extends Data {
  constructor({ form, updateStore, Logic, component }) {
    super({ form, module: 'data', dataId: 'terrenos_links', updateStore, Logic, component, originClass: TerrenosLinks })
  }
  build = async ({ register, fields, companySpecialFields }) => {
    const specialFields = {
      irParaTerrenoButton: irParaTerrenoButton,
    }
    Object.assign(specialFields, companySpecialFields)
    this.form.build({ register, fields, specialFields })
    return this
  }
}